import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'app-cliente-moral-form',
    templateUrl: './cliente-moral-form.component.html',
    styleUrls: ['../cliente-form.component.scss'],
    // Esto enlaza mágicamente las validaciones HTML de este hijo directo al formulario global del padre
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class ClienteMoralFormComponent {
    @Input() cliente: any;
    @Input() paises: any[] = [];
    @Input() listaEstados: string[] = [];

    @Output() addRepresentante = new EventEmitter<void>();
    @Output() removeRepresentante = new EventEmitter<number>();
    @Output() fileSelected = new EventEmitter<{ file: File, campo: string }>();
    @Output() triggerDownload = new EventEmitter<any>();

    // 1. Mantiene tu función original por si tienes inputs de archivo directos de la empresa
    public forwardFile(event: any, fieldName: string): void {
        if (event.target.files && event.target.files.length > 0) {
            this.fileSelected.emit({ file: event.target.files[0], campo: fieldName });
        }
    }

    // 2. NUEVA FUNCIÓN: Para interceptar los archivos del componente atómico (representantes)
    public forwardRepresentativeFile(event: { file: File, campo: string }, index: number): void {
        // Intercepta el evento que emite el subcomponente y lo reformatea para PHP
        const campoEstructurado = `representantes[${index}][${event.campo}]`;
        this.fileSelected.emit({ file: event.file, campo: campoEstructurado });
    }
}


// WEBPACK FOOTER //
// ./src/app/clientes/cliente-form/component-form/cliente-moral-form.component.ts